import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  salehis: [],
};

const saleHisSlice = createSlice({
  name: "salehis",
  initialState,
  reducers: {
    addSaleHis: (state, action) => {
      state.salehis = action.payload;
    },

  },
});
export const {
    addSaleHis,
} = saleHisSlice.actions;
export default saleHisSlice.reducer;
